import * as d3 from 'd3';

export const formatProportion = d3.format('.0%');
